import { useSearchParams } from 'react-router-dom';
import { SheetsOverview } from './SheetsOverview.js';
import { Exports } from './Exports.js';
import { History } from './History.js';
import { Sheets } from './Sheets.js';

const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'exports', label: 'Exports' },
  { key: 'history', label: 'History' },
  { key: 'connections', label: 'Connections' },
] as const;

type TabKey = (typeof TABS)[number]['key'];

export function SheetsHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get('tab') as TabKey) || 'overview';

  function setTab(tab: TabKey) {
    if (tab === 'overview') {
      setSearchParams({});
    } else {
      setSearchParams({ tab });
    }
  }

  return (
    <div className="space-y-6">
      {/* Tab bar */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex gap-6">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setTab(tab.key)}
              className={`whitespace-nowrap border-b-2 pb-3 pt-1 text-sm font-medium transition-colors ${
                activeTab === tab.key
                  ? 'border-brand-500 text-brand-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === 'overview' && <SheetsOverview />}
      {activeTab === 'exports' && <Exports />}
      {activeTab === 'history' && <History />}
      {activeTab === 'connections' && <Sheets />}
    </div>
  );
}
